// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"WE-z","smallCardRow":"XE-z","largeCardRow":"YE-z","productSearchRow":"ZE-z","curatedRow":"_E-z"};